export const lastFriday = () => {
  return fridayBefore(new Date());
};

export const fridayBefore = date => {
  const day = 1000 * 60 * 60 * 24;
  let lastFriday = new Date(date.getTime() - day);
  while (lastFriday.getDay() !== 5)
    lastFriday = new Date(lastFriday.getTime() - day);
  const formattedLastFriday = lastFriday.toISOString().replace(/T.+$/, "");
  return formattedLastFriday;
};



/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/